import useUsuario from "~fetchs/useUsuario";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Formik, Form, Field, FieldArray } from "formik";

import MaskedInput from "react-text-mask";
import InputField from "~components/Form/components/InputField";
import ContainerForm from "~components/Form/components/ContainerForm";
import mask from "~services/utils/mask";
import Select from "~components/Form/components/Select";
import prepareForOptions from "~services/utils/prepareForOptions";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";
import formatDate from "~services/utils/formatDate";
import { GetIndexBD } from "~services/utils/GetIndexBD";
import StatusModal from "~components/Modal/ModalStatus";
import useModalStatus from "~components/Modal/hooks/useModalStatus";
import useProspectValidate from "../hooks/useProspectValidate";
import { initialPath } from "~misc/paths";
import {
  useSalvarProspect,
  useVincularProspect,
  useSetInativarProspect,
} from "../../hooks/useWallet";
import { set, get } from "idb-keyval";
import useSelect from "~components/Form/hooks/useSelect";
import { ClosedProspect, DeleteEdit, IconClosed, IconClosed2, ModalClosed, SaveProspect } from "~misc/icons";
import "../styles.scss";
import useModalAction from "~components/Modal/hooks/useModalAction";
import ModalAction from "~components/Modal/ModalAction";
import { useNavigate } from "react-router-dom";
import Loader from "~components/Form/components/Loader";
import ModalResponse from "~components/Modal/ModalResponse";
import useModalResponse from "~components/Modal/hooks/useModalResponse";

import originControl from "~services/utils/originControl";
import AddressForm from "~components/Form/components/AddressForm";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import useSegmento from "~/fetchs/useSegmento";
import useGrupoSegmento from "~/fetchs/useGrupoSegmento";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import useProspect from "~/fetchs/useProspect";
import useFilial from "~/fetchs/useFilial";

import useCeps from "~/fetchs/useCeps";
import ExcluirModal from "~pages/PricesTable/components/Modal/ExcluirModal";
import { saveLocalStorage } from "~services/utils/SaveIndexBD";
import { db } from "~/db/db";
import ProspectConversionModal from "./ProspectConversionModal";
import useCargo from "~/fetchs/useCargo";
import useParametros from "~/fetchs/useParametros";
import useMicrorregiao from "~fetchs/useMicrorregiao";
import RegistrationJourneyModals from "../../components/RegistrationJourneyModals";
import { permiteNomeObra, normalizeNomeObra } from "~services/utils/nomeObra";

const ProspectEditForm = ({ parameter = 0 }) => {
  const { usuario } = useUsuario();
  const { formatNumber, cpfCnpj, formatCpfCnpjValue } = mask();
  const { validationSchema, initialValues, valuess, setValue, setinitialValues } = useProspectValidate();

  const { getOrigem, origens, parameters } = originControl();

  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();

  const { isModalOpenStatus, closeModalStatus, openModalStatus } = useModalStatus();

  const [linkResponse, setLinkResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const formikRef = useRef();
  const ArrayContatoRef = useRef();
  const initialTrilhaIdRef = useRef(null);
  const initialGrupoCentralizadorConstrutoraIdRef = useRef(null);
  const lastInitializedClienteIdRef = useRef(null);
  const lastInitialValuesRef = useRef(null);
  const newContato = {
    nome: "",
    sobrenome: "",
    cargoId: null,
    email: "",
    telefone: "",
    celular: "",
  };
  const navigate = useNavigate();

  const {
    isModalOpenAction: isModalInativarOpenAction,
    closeModalAction: closeModalInativarAction,
    openModalAction: openModalInativarAction,
    setModalOpenAction: setModalInativarOpenAction,
  } = useModalAction();
  const {
    isModalOpenAction: isModalConverterOpenAction,
    closeModalAction: closeModalConverterAction,
    openModalAction: openModalConverterAction,
    setModalOpenAction: setModalConverterOpenAction,
  } = useModalAction();

  //States
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [prospectData, setProspectData] = useState({});
  const [loadingx, setLoadingx] = useState(true);
  const checkedGrupoRef = useRef(false);
  const { prospect: cliente, useRemoveCallback } = useProspect(parameter);
  const [initializedCliente, setInitializedCliente] = useState(false);
  const [initializedTrilha, setInitializedTrilha] = useState(false);

  const [enableInativarProspect, setEnableInativarProspect] = useState(false);

  const prospectInativado = useSetInativarProspect(parameter, enableInativarProspect);
  const onSuccess = () => {
    setLoading(false);
    navigate(`${initialPath}/carteira/prospect`, {
      state: { successProspectUpdated: true },
      replace: true,
    });
  };

  const onError = () => {
    setLoading(false);
  };

  const onSuccessVinculo = () => {
    setLoading(false);
    setModalConversionIsOpen(false);
    closeModalConverterAction();

    setMessageStatus("Vinculo adicionado com sucesso!");
    setLinkResponse(`${initialPath}/carteira/prospect`);
    openModal("success");
  };

  const onErrorVinculo = (error) => {
    setLoading(false);
    setModalConversionIsOpen(false);
    closeModalConverterAction();

    setMessageStatus(error?.message || "Houve um erro ao vincular o prospect, tente novamente.");
    setLinkResponse(null);
    openModal("alert");
  };

  const prospectSalvar = useSalvarProspect(prospectData, onSuccess, onError);
  const prospectVincular = useVincularProspect(onSuccessVinculo, onErrorVinculo);

  //IndexsDB
  // const [carteira, setCarteiraData] = useState({});
  const { optionsTrilha, trilhas, trilha, onChangeTrilha, trilhaSelect, SetSelectTrilha, trilhasObjId, trilhasObjCodigo, trilhasObjNome } = useTrilha(formikRef);
  const { gruposCentralizadores } = useGrupoCentralizador(formikRef, "grupoCentralizadorId", { trilhaId: trilha });
  const { optionsGrupoSegmento, grupoSegmento, grupoSegmentoSelect, onChangeGrupoSegmento, SetSelectGrupoSegmento } =
    useGrupoSegmento({ formikRef, trilha });
  const { optionsSegmento, segmentoSelect, onChangeSegmento, SetSelectSegmento } = useSegmento(
    grupoSegmento,
    formikRef
  );

  const trilhaNome = (cliente?.trilha?.nome
    ?? trilhas.find((item) => String(item.id) === String(cliente?.trilhaId))?.nome)?.toLowerCase();
  const acessoJornadaFunil = ["imo", "infra"].includes(trilhaNome) && usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');

  const { optionMicrorregioes, microrregiaoSelect, onChangeMicrorregiao, SetSelectMicrorregiao } = useMicrorregiao({ formikRef });
  const { filial, optionFiliais, onChangeFilial, SetSelectFilial, filialSelect } = useFilial({ formikRef });
  const [produtos, setProdutos, produtoSelect, onChangeProduto] = useState([]);
  const [produtosFiliais, setProdutosFiliais] = useState([]);
  const { optionsCargo, cargoSelect, handleCargoChange, SetSelectCargo } = useCargo(formikRef);
  const { toObjectSlug } = useParametros();
  const grupoCentralizadorConstrutoraSelect = useSelect("grupoCentralizadorConstrutoraId");
  const grupoCentralizadorConstrutoraParam = toObjectSlug["grupos-centralizador-construtoras"];
  const filteredGrupoCentralizador = gruposCentralizadores || [];

  const [grupoOptionsState, setGrupoOptionsState] = useState([]);
  const [grupoOptionsLoaded, setGrupoOptionsLoaded] = useState(false);
  const [selectedGrupoOption, setSelectedGrupoOption] = useState(null);
  const [grupoLoading, setGrupoLoading] = useState(true);
  const loadGrupoOptions = useCallback(() => {
    if (grupoOptionsLoaded) return;

    setGrupoLoading(true);
    setTimeout(() => {
      const prepared = prepareForOptions(filteredGrupoCentralizador, ["codigo", "nome"], "id");
      setGrupoOptionsState(prepared);
      setGrupoOptionsLoaded(true);
      setGrupoLoading(false);
    }, 40);
  }, [filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading]);



  useEffect(() => {
    const currentId = formikRef.current?.values?.grupoCentralizadorConstrutoraId ?? initialGrupoCentralizadorConstrutoraIdRef.current;
    if (!currentId) {
      setSelectedGrupoOption(null);
      return;
    }

    if (grupoOptionsLoaded) {
      const match = grupoOptionsState.find((opt) => String(opt.value) === String(currentId));
      if (match) {
        setSelectedGrupoOption(match);
        return;
      }
    }

    const found = filteredGrupoCentralizador.find((g) => String(g.id) === String(currentId));
    if (found) setSelectedGrupoOption({ value: found.id, label: found.nome || found.codigo });
  }, [initializedCliente, grupoOptionsLoaded, grupoOptionsState, filteredGrupoCentralizador]);
  const trilhasPermitidas = useMemo(() => {
    const raw = grupoCentralizadorConstrutoraParam?.valor || "";
    const codigos = raw
      .split(",")
      .map((codigo) => codigo.trim().toUpperCase())
      .filter(Boolean);
    return codigos
      .map((codigo) => trilhasObjCodigo?.[codigo]?.id || trilhasObjNome?.[codigo]?.id)
      .filter(Boolean);
  }, [grupoCentralizadorConstrutoraParam?.valor, trilhasObjCodigo, trilhasObjNome]);
  const isTrilhaPermitida = trilhasPermitidas.includes(trilha);
  const imoTrilhaId =
    trilhasObjNome?.IMO?.id || trilhasObjCodigo?.IMO?.id || trilhasObjCodigo?.["410"]?.id;
  const isTrilhaIMO = imoTrilhaId ? String(trilha) === String(imoTrilhaId) : false;
  const exibirNomeObra = permiteNomeObra(trilhasObjId?.[`key-${trilha}`]);
  const onChangeGrupoCentralizadorConstrutora = (e) => {
    const value = e?.value ?? null;
    if (e?.value) setSelectedGrupoOption(e);
    else setSelectedGrupoOption(null);
    grupoCentralizadorConstrutoraSelect.upDateValue(value || "");
    grupoCentralizadorConstrutoraSelect.upDateDefaultValue(e || "");
    formikRef.current?.setFieldValue("grupoCentralizadorConstrutoraId", value);
    setTimeout(() => formikRef.current?.setFieldTouched("grupoCentralizadorConstrutoraId", true));
  };
  useEffect(() => {
    if (!grupoOptionsLoaded && isTrilhaPermitida && filteredGrupoCentralizador && filteredGrupoCentralizador.length > 0) {
      loadGrupoOptions();
    }
  }, [isTrilhaPermitida, filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading, loadGrupoOptions]);
  //FunctionsIndexDB
  async function initializeCliente() {
    if (!cliente || !cliente.id) return;
    if (lastInitializedClienteIdRef.current === cliente.id) return;
    lastInitializedClienteIdRef.current = cliente.id;

    if (Array.isArray(cliente.contatos) && cliente.contatos.length == 0) {
      cliente.contatos.push(newContato);
    }

    const dataFiltered = {
      ...cliente?.cliente,
      ...cliente?.produtoFilial,
      ...cliente?.endereco,
      ...cliente?.endereco?.cidade,
      estadoId: cliente?.endereco?.cidade?.estado?.id,
      cidadeId: cliente?.endereco?.cidade?.id,
      negociacaoDate: cliente?.cliente?.dataNegociacao ? formatDate(cliente.cliente.dataNegociacao) : "",
      faseObra: cliente.faseObra ?? "",
      numeroPavimentos: null,
      quantidadeTorres: null,
      sistemaConstrutivo: null,
      filialId: cliente.produtoFilialId ?? "",
      grupoCentralizadorConstrutoraId: cliente?.grupoCentralizadorConstrutoraId ?? null,
      ...cliente,
    };

    SetSelectTrilha(cliente?.trilhaId);
    SetSelectFilial(cliente?.filialId);
    SetSelectSegmento(cliente?.segmentoId);
    SetSelectMicrorregiao(cliente?.microrregiaoId);
    SetSelectCargo(cliente?.contatos);
    SetSelectGrupoSegmento(cliente?.grupoSegmentoId);

    initialTrilhaIdRef.current = cliente?.trilhaId ?? null;
    initialGrupoCentralizadorConstrutoraIdRef.current = cliente?.grupoCentralizadorConstrutoraId ?? null;

    try {
      const prev = formikRef.current?.values || {};
      const partial = {
        ...prev,
        cep: cliente?.endereco?.cep,
        rua: cliente?.endereco?.rua,
        bairro: cliente?.endereco?.bairro,
        numero: cliente?.endereco?.numero,
        complemento: cliente?.endereco?.complemento,
        cidade: cliente?.endereco?.cidade ?? null,
        cidadeId: cliente?.endereco?.cidade?.id ?? null,
        uf: cliente?.endereco?.cidade?.estado?.sigla ?? null,
      };
      if (formikRef.current && typeof formikRef.current.setValues === "function") {
        formikRef.current.setValues(partial);
      } else {
        formikRef.current?.setFieldValue("cep", cliente?.endereco?.cep);
        formikRef.current?.setFieldValue("rua", cliente?.endereco?.rua);
        formikRef.current?.setFieldValue("bairro", cliente?.endereco?.bairro);
        formikRef.current?.setFieldValue("numero", cliente?.endereco?.numero);
        formikRef.current?.setFieldValue("complemento", cliente?.endereco?.complemento);
        formikRef.current?.setFieldValue("cidade", cliente?.endereco?.cidade ?? null);
        formikRef.current?.setFieldValue("cidadeId", cliente?.endereco?.cidade?.id ?? null);
        formikRef.current?.setFieldValue("uf", cliente?.endereco?.cidade?.estado?.sigla ?? null);
      }

      setInitializedCliente(true);

      const dataFilteredStr = JSON.stringify(dataFiltered || {});
      if (lastInitialValuesRef.current !== dataFilteredStr) {
        setinitialValues(dataFiltered);
        lastInitialValuesRef.current = dataFilteredStr;
      }
    } catch (e) {
      setinitialValues(dataFiltered);
      setInitializedCliente(true);
    }
  }
  const todeleteCallback = useRemoveCallback();

  //useEffects
  useEffect(() => {
    const clienteId = cliente?.id;
    if (!clienteId) return;
    if (lastInitializedClienteIdRef.current === clienteId) return;
    initializeCliente();
  }, [cliente?.id]);

  useEffect(() => {
    if (Object.keys(prospectData).length > 0) {
      prospectSalvar();
    }
  }, [prospectData]);

  useEffect(() => {
    if (!formikRef.current) return;

    const currentTrilhaId = formikRef.current.values?.trilhaId;
    const currentId =
      formikRef.current.values?.grupoCentralizadorConstrutoraId ??
      initialGrupoCentralizadorConstrutoraIdRef.current;

    if(currentTrilhaId && trilhasPermitidas.length > 0) {
      setLoadingx(false);
    }
    if (!isTrilhaPermitida) {
      const isInitialTrilha =
        String(currentTrilhaId || "") === String(initialTrilhaIdRef.current || "");
      if (isInitialTrilha && initialGrupoCentralizadorConstrutoraIdRef.current) {
        return;
      }
      if (formikRef.current.values?.grupoCentralizadorConstrutoraId) {
        onChangeGrupoCentralizadorConstrutora(null);
      }
      return;
    }

    if (!grupoOptionsLoaded && !filteredGrupoCentralizador?.length) return;

    if (currentId === null || currentId === undefined || currentId === "") return;

    let currentOption;
    if (grupoOptionsLoaded) {
      currentOption = grupoOptionsState.find((opt) => String(opt.value) === String(currentId));
    } else {
      const found = filteredGrupoCentralizador.find((g) => String(g.id) === String(currentId));
      if (found) currentOption = { value: found.id, label: found.nome || found.codigo };
    }

    if (!currentOption) return;

    onChangeGrupoCentralizadorConstrutora(currentOption);
  }, [isTrilhaPermitida, filteredGrupoCentralizador, trilha, grupoOptionsLoaded, grupoOptionsState]);

  useEffect(() => {
    if (prospectInativado.data && enableInativarProspect) {
      setModalInativarOpenAction(false);

      if (prospectInativado.isSuccess && !prospectInativado?.data?.status) {
        setEnableInativarProspect(false);
        db.cliente.update(parseInt(parameter), { ativo: false }).then(data => {
          todeleteCallback().finally(e => {
            setEnableInativarProspect(false);
            openModal("success");
            setMessageStatus("Prospect inativado com sucesso!");
            setLinkResponse(`${initialPath}/carteira/prospect`);
          });
        })

      } else {
        openModal("alert");
        setMessageStatus("Erro ao inativar prospect!");
      }
    }
  }, [prospectInativado.data]);

  async function submit(values) {
    const fields = {
      ...values,
      segmento: null,
      grupoCentralizador: null,
      ultimoEnvio: new Date().toLocaleString(),
      dataNascimento: values.dataNascimento ? values.dataNascimento.split("/").reverse().join("-") : null,
      dataNegociacao: values.negociacaoDate ? values.negociacaoDate.split("/").reverse().join("-") : null,
      filialId: values.filialId ?? null,
      numeroPavimentos: null,
      quantidadeTorres: null,
      sistemaConstrutivo: null,
      grupoCentralizadorConstrutoraId: values.grupoCentralizadorConstrutoraId ?? null,
      nomeObra: normalizeNomeObra(values.nomeObra, exibirNomeObra),
      endereco: {
        ...values.endereco,
      },
    };

    const trilhaId = values.trilhaId ?? trilha;
    const selectedTrilha = Array.isArray(trilhas)
      ? trilhas.find((item) => String(item.id) === String(trilhaId))
      : null;
    if (selectedTrilha) {
      fields.trilha = selectedTrilha;
    }

    delete fields.endereco.cidade;

    if (Array.isArray(fields.contatos)) {
      const originalHadContacts = !!(cliente?.contatos && cliente.contatos.length > 0);
      fields.contatos = fields.contatos.map((c) => {
        const t = { ...c };
        if (!originalHadContacts || !t.id || t.id === 0) {
          delete t.id;
        }
        return t;
      });
    }
    setProspectData(fields);
  }

  function vincular(clienteId) {
    const fields = {
      ProspectId: cliente?.id,
      ClienteId: clienteId,
    };

    prospectVincular(fields);
  }

  function fecharProspect() {
    setModalInativarOpenAction(true);
  }
  function converterProspect() {
    setModalConverterOpenAction(true);
  }

  function SimInativar() {
    setEnableInativarProspect(true);
  }
  function NaoInativar() {
    setModalInativarOpenAction(false);
  }
  function SimConverter() {
    saveLocalStorage("conversao-prospect", initialValues, true);
    navigate(
      `${initialPath}/carteira/busca/online?origem=${origens.busca_online}&${parameters.parametros_persistentes}=${origens.conversao_prospect}`
    );
  }
  function NaoConverter() {
    saveLocalStorage("conversao-prospect", initialValues, true);
    navigate(
      initialPath +
      `/carteira/emissor/novo?origem=${origens.conversao_prospect}&${parameters.parametros_persistentes}=${origens.conversao_prospect}`
    ); //TK = TOKEEP
  }

  const [exibirTodosContatos, setExibirTodosContatos] = useState(false);

  const initialValuesEdit = useMemo(() => ({
    ...initialValues,
    documento: formatCpfCnpjValue(initialValues.documento || ""),
    nomeObra: initialValues.nomeObra ?? "",
    dataNascimento: initialValues.dataNascimento
      ? initialValues.dataNascimento.split("T")[0].split("-").reverse().join("/")
      : "",
    contatos:
      initialValues.contatos?.map((contato, index) => ({
        id: contato.id ?? null,
        nome: contato.nome || null,
        sobrenome: contato.sobrenome || null,
        cargoId: contato.cargoContato?.id ? contato.cargoContato?.id : null,
        cargo: contato.cargoContato?.nome ? contato.cargoContato?.nome : '',
        email: contato.email || null,
        telefone: contato.telefone || null,
        celular: contato.celular || null,
        fonte: contato.fonte || null,
      })) || [],
  }), [initialValues, formatCpfCnpjValue]);

  const [removeBlock, setremoveBlock] = useState({
    arrayContatos: [],
    index: null,
  });
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [indexBlock, setIndexBlock] = useState(null);

  function RemoveBlock() {
    removeBlock.arrayContatos[0].remove(removeBlock.index);
    setIsConfirmationOpen(false);
  }
  function HandleRemoveBlock(arrayContatos, index) {
    setIsConfirmationOpen(true);
    setIndexBlock(index);

    setremoveBlock((prevState) => ({
      // Mantenha os valores antigos do estado
      ...prevState,
      // Atualize o arrayContatos adicionando um novoContato
      arrayContatos: [...prevState.arrayContatos, arrayContatos],
      index: index,
    }));
  }

  function HandleRemoveBlockClosed() {
    setIsConfirmationOpen(false);
  }
  const [cepteste, setCep] = useState("");
  const { cep } = useCeps({
    codigoPostal: cepteste || "",
  });
  useEffect(() => {
    if (cliente?.endereco?.cep !== undefined) {
      const formattedCep = cliente?.endereco?.cep.replace(/\D/g, "");
      setCep(formattedCep);
    }
  }, [cliente]);

  const [modalConversionIsOpen, setModalConversionIsOpen] = useState(false);

  const [modalCodeExistentIsOpen, setModalCodeExistentIsOpen] = useState(false);
  const [teste, setTeste] = useState(false)

  const expandirTodosContatos = useCallback(() => {
    setExibirTodosContatos(true);
    setTeste(true);
  }, []);
  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValuesEdit}
      validationSchema={validationSchema}
      onSubmit={async (values, { setFieldError }) => {
        try {
          if (isTrilhaIMO && isTrilhaPermitida && !values.grupoCentralizadorConstrutoraId) {
            setFieldError(
              "grupoCentralizadorConstrutoraId",
              "Grupo Centralizador Construtoras e obrigatório"
            );
            return;
          }
          setLoading(true);

          SaveIndexBD("form-edit-prospect", values);
          await new Promise((resolve) => setTimeout(resolve, 2000));
          submit(values);
        } catch (e) {

          setLoading(false);
        }
      }}
      enableReinitialize
    >
      {({ errors, touched, setFieldValue, setFieldTouched, values, isSubmitting }) => (
        <Form className="mt-[0rem]" id="prospect">
          <div className={loading ? "relative spinner__form-active" : "relative"}>
            <ContainerForm title="Dados Cadastrais">
              <div className="grid gap-x-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-12">
                <Select
                  name="trilhaId"
                  label="Trilha Global: "
                  placeholder="Trilha Global:"
                  options={optionsTrilha}
                  noOptionsMessage="Trilha não encontrado"
                  onChange={onChangeTrilha}
                  errors={errors.trilhaId}
                  touched={touched.trilhaId}
                  {...trilhaSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-1 lg:col-span-6` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                  isRequired
                />
                <Select
                  name="grupoSegmentoId"
                  label="Grupo Segmento: "
                  placeholder="Grupo Segmento:"
                  options={optionsGrupoSegmento}
                  noOptionsMessage="Grupo não encontrado"
                  onChange={onChangeGrupoSegmento}
                  isDisabled={!values.trilhaId}
                  errors={errors.grupoSegmentoId}
                  touched={touched.grupoSegmentoId}
                  {...grupoSegmentoSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-1 lg:col-span-6` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                  isRequired
                />
                <Select
                  name="segmentoId"
                  label="Segmento: "
                  placeholder="Segmento:"
                  options={optionsSegmento}
                  noOptionsMessage="Grupo não encontrado"
                  onChange={onChangeSegmento}
                  isDisabled={!values.grupoSegmentoId}
                  errors={errors.segmentoId}
                  touched={touched.segmentoId}
                  {...segmentoSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-1 lg:col-span-4` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                  isRequired
                />
                {isTrilhaPermitida && (
                  <Select
                    name="grupoCentralizadorConstrutoraId"
                    label="Grupo Centralizador Construtoras:"
                    placeholder="Grupo Centralizador Construtoras:"
                    options={grupoOptionsLoaded ? grupoOptionsState : selectedGrupoOption ? [selectedGrupoOption] : []}
                    value={selectedGrupoOption}
                    onMenuOpen={loadGrupoOptions}
                    loading={grupoLoading}
                    isDisabled={grupoLoading || !values.trilhaId}
                    noOptionsMessage="Grupo Centralizador Construtoras não encontrado"
                    onChange={onChangeGrupoCentralizadorConstrutora}
                    errors={errors.grupoCentralizadorConstrutoraId}
                    touched={touched.grupoCentralizadorConstrutoraId}
                    isRequired={isTrilhaIMO}
                    className="col-span-12 sm:col-span-1 lg:col-span-4"
                  />
                )}
                <Select
                  name="microrregiaoId"
                  label="Microrregião:"
                  placeholder="Microrregião:"
                  options={optionMicrorregioes}
                  noOptionsMessage="Microrregião não encontrada"
                  onChange={onChangeMicrorregiao}
                  errors={errors.microrregiaoId}
                  touched={touched.microrregiaoId}
                  {...microrregiaoSelect}
                  className={isTrilhaPermitida ? `col-span-12 sm:col-span-2 lg:col-span-4` : `col-span-12 sm:col-span-1 lg:col-span-3`}
                />
              </div>
              <div className={`grid gap-x-4 md:grid-cols-1 lg:grid-cols-${initialValues.dataNascimento ? "3" : "2"}`}>
                <InputField
                  labelName="CNPJ/CPF:"
                  inputName="documento"
                  as={MaskedInput}
                  mask={cpfCnpj}
                  inputMask="onmask"
                  inputType="text"
                  forceUppercase
                // isDisabled={true}
                />
                <InputField
                  labelName="Nome Fantasia:"
                  inputName="nomeFantasia"
                  inputMask="offmask"
                  inputType="text"
                // isDisabled={true}
                />
                {initialValues.dataNascimento && (
                  <InputField
                    labelName="Data de Nascimento:"
                    inputName="dataNascimento"
                    inputMask="offmask"
                    inputType="text"
                    isRequired={values.tipo == 1}
                  // isDisabled={true}
                  />
                )}
              </div>
              <AddressForm
                formikRef={formikRef}
                dataComingBack={{
                  estado: cliente?.endereco?.cidade?.estado ?? null,
                  cidade: cliente?.endereco?.cidade ?? null,
                }}
              />
              {exibirNomeObra && (
                <InputField labelName="Nome da Obra:" inputName="nomeObra" inputMask="offmask" inputType="text" />
              )}
            </ContainerForm>
            <FieldArray
              name="contatos"
              render={(arrayContatos) => {
                ArrayContatoRef.current = arrayContatos;
                const contatosToDisplay = values.contatos;
                return (
                  <div className="container relative">
                    <ContainerForm title="Dados Pessoais">
                      {contatosToDisplay.map((data, index) => (
                        <>
                          <div
                            className={`relative rounded-lg grid gap-x-4 md:grid-cols-1 lg:grid-cols-2 ${index % 2 != 0 ? " bg-[#DAE8F9] p-3" : ""
                              } ${contatosToDisplay.length > 1 && exibirTodosContatos ? " pt-12 " : ""}  ${index > 0 && teste === false ? 'hidden' : 'block'}`}
                            key={index}
                          >
                            {contatosToDisplay.length > 1 && exibirTodosContatos && (
                              <button
                                type="button"
                                className="scale-75 absolute top-0 right-0"
                                onClick={() => HandleRemoveBlock(arrayContatos, index)}
                              >
                                <DeleteEdit />
                              </button>
                            )}
                            <InputField
                              labelName="Nome Contato:"
                              inputName={`contatos[${index}].nome`}
                              inputMask="offmask"
                              inputType="text"
                              hasImage={true}
                              setFieldValue={setFieldValue}
                              defaultValue={data && data.nome}
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Sobrenome Contato:"
                              inputName={`contatos[${index}].sobrenome`}
                              inputMask="offmask"
                              inputType="text"
                              hasImage={true}
                              setFieldValue={setFieldValue}
                              defaultValue={data && data.sobrenome}
                              isRequired
                              difference={true}
                            />


                            <Select
                              name={`contatos[${index}].cargoId`}
                              label="Cargo:"
                              placeholder=""
                              options={optionsCargo}
                               value={
                                  values.contatos[index].cargoId
                                    ? {
                                        label: values.contatos[index].cargo,
                                        value: values.contatos[index].cargoId,
                                      }
                                    : null
                                }

                              onChange={(e) => {
                                handleCargoChange(index, setFieldValue, setFieldTouched)(e);
                                setFieldValue(`contatos[${index}].cargo`, e.label);
                                // setTimeout(() => setFieldTouched(`contatos[${index}].cargo`, true));
                              }}
                              errors={errors.contatos && errors?.contatos[index]?.cargoId}
                              touched={touched.contatos && touched?.contatos[index]?.cargoId}
                              isRequired
                            />

                            <InputField
                              labelName="Email do Contato:"
                              inputName={`contatos[${index}].email`}
                              inputMask="offmask"
                              inputType="text"
                              hasImage={true}
                              setFieldValue={setFieldValue}
                              defaultValue={data && data.email}
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 1:"
                              inputName={`contatos[${index}].telefone`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              hasImage={true}
                              setFieldValue={setFieldValue}
                              defaultValue={data && data.telefone}
                              isRequired
                              difference={true}
                            />
                            <InputField
                              labelName="Telefone de contato 2:"
                              inputName={`contatos[${index}].celular`}
                              as={MaskedInput}
                              mask={formatNumber}
                              inputMask="onmask"
                              inputType="text"
                              hasImage={true}
                              setFieldValue={setFieldValue}
                              defaultValue={data && data.celular}
                              difference={true}
                            />
                          </div>
                          <div className="flex items-center">
                            {((contatosToDisplay.length > 1 && index == contatosToDisplay.length - 1) ||
                              contatosToDisplay.length == 1) && (
                                <button
                                  type="button"
                                  className="mt-4 py-2 px-3 bg-primaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search "
                                  onClick={() => {
                                    setExibirTodosContatos(true);
                                    setTeste(true);
                                    arrayContatos.push({
                                      nome: "",
                                      sobrenome: "",
                                      cargoId: null,
                                      email: "",
                                      telefone: "",
                                      celular: "",
                                    });
                                  }}
                                >
                                  Adicionar um novo contato
                                </button>
                              )}
                          </div>
                        </>
                      ))}
                    </ContainerForm>
                  </div>
                );
              }}
            ></FieldArray>

            <div className="flex flex-col md:flex-row gap-x-4 container buttons-prospect mt-12 mb-6">
              <button
                type="button"
                onClick={fecharProspect}
                className="text-white font-bold p-4 relative rounded-full bg-recusado mb-4 md:mb-0 md:w-[50%]"
              >
                Inativar Prospect
                <span className="absolute right-5">
                  <ClosedProspect />
                </span>
              </button>
              <button
                type="button"
                onClick={() => {
                  setModalCodeExistentIsOpen(true);
                }}
                className="text-primaira font-bold p-4 relative rounded-full bg-secundaria md:w-[50%]"
              >
                Converter Cliente
                <span className="absolute right-5">
                  <SaveProspect />
                </span>
              </button>
            </div>
          </div>
          {loading && (
            <>
              <div className="spinner__form ">
                <Loader />
              </div>
            </>
          )}

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} onInvalid={expandirTodosContatos} />

          <ModalResponse
            isOpen={isModalOpen}
            closeModal={(e) => {
              if (modalStatus == "success") navigate(`${initialPath}/carteira/prospect`);

              closeModal();
            }}
            status={modalStatus}
            message={messageStatus}
            submessage={submessageStatus}
            link={linkResponse}
          />

          <ModalAction
            isOpen={isModalInativarOpenAction}
            onClose={closeModalInativarAction}
            title="Deseja inativar esse cliente prospect?"
            sub="As informações deste cliente serão removidas da sua carteira"
            buttonOne="Sim"
            buttonTwo="Não"
            linkOne={SimInativar}
            linkTwo={NaoInativar}
          />
          <ModalAction
            isOpen={isModalConverterOpenAction}
            onClose={closeModalConverterAction}
            title="Prospect já possui código emissor?"
            sub="(Já possui matriz/escritório?)"
            buttonOne="Sim"
            buttonTwo="Não"
            linkOne={SimConverter}
            linkTwo={NaoConverter}
          />
          <ExcluirModal
            isOpen={isConfirmationOpen}
            onClose={HandleRemoveBlockClosed}
            onConfirm={RemoveBlock}
            onCancel={HandleRemoveBlockClosed}
            mensagem={`Tem certeza de que deseja excluir o bloco ${indexBlock}`}
          />
          <StatusModal
            isOpen={isModalOpenStatus}
            onClose={closeModalStatus}
            title="Prospect salvo com sucesso!"
            buttonOne="Ok"
            buttonTwo={null}
            linkOne={`${initialPath}/carteira/prospect`}
            linkTwo={null}
          />

          <ModalAction
            isOpen={modalCodeExistentIsOpen}
            sub={<strong>Código de cliente já existe?</strong>}
            buttonOne={"Sim"}
            buttonTwo={"Não"}
            linkOne={() => {
              setModalCodeExistentIsOpen(false);
              setModalConversionIsOpen(true);
            }}
            linkTwo={() => {
              setModalCodeExistentIsOpen(false);
              openModalConverterAction();
            }}
            onClose={() => {
              setModalCodeExistentIsOpen(false);
            }}
          />

          <RegistrationJourneyModals
            clienteId={cliente?.id} 
            clienteCodigo={cliente?.codigoProspect} 
            tipo="prospect"
            enabled={acessoJornadaFunil} 
            rotaFinal={`${initialPath}/carteira/prospect`}
          />

          <ProspectConversionModal
            isOpen={modalConversionIsOpen}
            onClose={() => {
              setModalConversionIsOpen(false);
            }}
            handleConfirm={vincular}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ProspectEditForm;
